module.exports = __webpack_public_path__ + "static/media/mailCustom.d34cdbc0.png";